import { serverApi } from "./serverApi";
import { LoadTest } from "../types/loadTestTypes";
import {ErrorType} from "../types/sharedTypes";

export const loadTestService = serverApi.injectEndpoints({
  endpoints: (build) => ({
    runLoadTest: build.mutation<void, LoadTest>({
      query: (body) => ({
        url: "/loadTest/run",
        method: "POST",
        body
      }),
      transformErrorResponse: (baseQueryReturnValue, meta): ErrorType | undefined => {
        return {
          status: meta?.response?.status,
          statusText: meta?.response?.statusText,
          message: (baseQueryReturnValue.data as any)?.errorCode
        }
      }
    }),
  })
});

export const {
  useRunLoadTestMutation
} = loadTestService;